@if (this.viewStateService.isMobileView) {
<header class="mobile-header">
  @if (this.viewStateService.currentView === 'devspace') {
  <section class="brand">
    <img src="assets/img/14. Home-Workspaces.svg" alt="DABubble" class="logo" />
  </section>
  } @else {
  <button class="go-to-devspace" (click)="this.viewStateService.currentView = 'devspace'">
    <img src="assets/icons/mobile-devspace-arrow.svg" alt="arrow" />
    <img class="logo-icon" src="assets/icons/devspace-logo.svg" alt="devspace logo" />
    <span>Devspace</span>
  </button>
  }
  <section>
    <div class="avatar-wrap" (click)="this.userMenuService.openUserMenu($event, user$)">
      <img
        class="avatar"
        [src]="(user$ | async)?.avatar"
        (error)="this.userMenuService.fallbackAvatar($event)"
        [alt]="(user$ | async)?.name || 'Avatar'"
      />
    </div>
  </section>
</header>
} @else {
<header class="ws-header">
  <section class="brand">
    <img src="assets/img/14. Home-Workspaces.svg" alt="DABubble" class="logo" />
  </section>

  <section class="search-wrap" #searchRoot>
    <input
      #searchInput
      class="search"
      matInput
      [formControl]="searchCtrl"
      placeholder="Devspace durchsuchen"
      autocomplete="off"
      aria-label="Suche"
      (input)="onSearchInput()"
      (keydown)="onSearchKeyDown($event)"
      [class.mention-open]="showMention"
    />

    @if (showMention) {
    <section class="mention-panel">
      <app-mention-list
        class="header-mention-list"
        [searchTerm]="mentionSearchTerm"
        [visible]="showMention"
        [mode]="mentionMode"
        [users]="mentionUsers"
        [channels]="mentionChannels"
        (pick)="insertMention($event)"
        (userSelected)="openDmFromMention($event)"
        (channelSelected)="openChannelFromMention($event)"
      ></app-mention-list>
    </section>
    }
  </section>

  <section>
    <section class="user" (click)="this.userMenuService.openUserMenu($event, user$)">
      <span class="name">{{ (user$ | async)?.name }}</span>

      <section class="avatar-wrap">
        <img
          class="avatar"
          [src]="(user$ | async)?.avatar"
          (error)="this.userMenuService.fallbackAvatar($event)"
          [alt]="(user$ | async)?.name || 'Avatar'"
        />
        <span class="status" [class.online]="(user$ | async)?.online"></span>
      </section>

      <mat-icon class="expand-icon">expand_more</mat-icon>
    </section>
  </section>
</header>
}
